<style scoped lang="scss" type="text/scss">
    .image-container {
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-position: center;
        position: relative;

        &.circular {
            border-radius: 50%;
        }
    }
</style>

<template>
    <div class="image-container" :class="{circular: circular}"
         :style="{'background-image': 'url(' + imageUrl + ')', 'background-size': imageSizeStyle}">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: '',
        props: {
            src: {
                type: String,
                default: ''
            },
            circular: {
                type: Boolean,
                default: false
            },
            useDefaultWhenNull: {
                type: Boolean,
                default: true
            }
        },
        data () {
            return {};
        },
        computed: {
            imageUrl () {
                if (this.src === null || this.src === undefined || this.src === '') {
                    if (this.useDefaultWhenNull === true) return this.imagePlaceholder;
                } else {
                    return this.src;
                }
            },
            imageSizeStyle () {
                return this.imageUrl === this.imagePlaceholder ? 'cover' : 'contain';
            },
            imagePlaceholder () {
                return this.$store.state.imagePlaceholder;
            }
        }
    };
</script>
